import { Badge, Space } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { saveScrollPosition } from "../../redux/discovers/discoversSlice";
import { AppDispatch, StoreState } from "../../redux/store";
import { updateTutorialVisibilityStatus } from "../../redux/users/usersSlice";
import { removeActiveProfileTabFromStorage } from "../../utls/FunctionsUtil";
import FormationModalComponent from "../Formations/Creators/Modals";

type props = {
  id: string;
  name: string;
  link: string;
  icon: string;
  activeIcon: string;
  handleDisableFeatureModal?: () => void;
  isActive?: boolean;
};

const FooterItemComponent: React.FC<props> = React.memo(
  ({ id, name, link, icon, activeIcon, handleDisableFeatureModal, isActive }) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    const { unreadConversations } = useSelector((state: StoreState) => state.messages);
    //const [presentationVideoNotification, setPresentationVideoNotification] = useState(0);
    //const [formationModalIsVisible, setFormationModalIsVisible] = useState<boolean>(false);
    const currentUserSettings = useSelector((state: StoreState) => state.users.currentUserSettings);

    // const checkAndHandleProfileModal = async () => {
    //   console.log("currentUserSettings", currentUserSettings?.visibilityStatus.hasSeenProfileModal);
    //   if (!currentUserSettings?.visibilityStatus.hasSeenProfileModal) {
    //     setFormationModalIsVisible(true);
    //   }
    // };
    //   }
    // };

    const handleProfileClick = async () => {
      if (pathname !== link) {
        if (!currentUserSettings?.visibilityStatus.hasSeenProfileModal) {
          localStorage.setItem("shouldShowProfileModal", "true");
        }
        navigate(link);
      }
      // } else {
      //   await checkAndHandleProfileModal();
      // }
    };

    // useEffect(() => {
    //   const shouldShowModal = localStorage.getItem("shouldShowProfileModal") === "true";
    //   if (shouldShowModal && id === FOOTER_IDS.PROFILE && pathname === link) {
    //     checkAndHandleProfileModal();
    //     localStorage.removeItem("shouldShowProfileModal");
    //   }
    // }, [pathname, id, link]);

    const handleTutorialRead = async () => {
      if (!currentUserSettings?.visibilityStatus.hasSeenProfileModal) {
        localStorage.removeItem("shouldShowProfileModal");
        dispatch(updateTutorialVisibilityStatus("hasSeenProfileModal"));
      }
    };

    const handleClick = () => {
      // TODO: enable this code for the upcoming event
      // const disableFeatures = [FOOTER_IDS.MESSAGING];
      // if (disableFeatures.includes(id)) {
      //   handleDisableFeatureModal?.();
      //   return;
      // }

      // Save scroll position if currently on discover page and navigating away
      if (pathname === "/common/discover" && link !== "/common/discover") {
        const swiperElement = document.querySelector(".swiper") as HTMLElement;
        if (swiperElement) {
          dispatch(saveScrollPosition(swiperElement.scrollTop));
        }
      }

      if (id === "profile") {
        handleProfileClick();
      } else {
        removeActiveProfileTabFromStorage();
        navigate(link);
      }
    };

    return (
      <>
        <Space
          className={`${isActive ? "text-white-color" : "text-grey-color"} 
        ${id === "messaging" ? "footerItemMsg" : id === "live" ? "footerItemLive" : "footerItem"} 
        cursor-pointer gap-5`}
          direction="vertical"
          align="center"
          onClick={handleClick}
        >
          {id === "messaging" ? (
            <Badge count={unreadConversations}>
              <img width={24} height={24} src={isActive ? activeIcon : icon} alt={`${name} icon`} />
            </Badge>
          ) : id === "profile" ? (
            <Badge dot={currentUserSettings?.expiredDiscovers || currentUserSettings?.rejectedDiscovers} className="profileDotNotification">
              <img
                width={24}
                height={24}
                src={isActive ? activeIcon : icon}
                alt={`${name} icon`}
                onClick={() => {
                  handleProfileClick();
                }}
              />
            </Badge>
          ) : id === "live" ? (
            <img width={45} height={24} src={isActive ? activeIcon : icon} alt={`${name} icon`} />
          ) : (
            <>
              <img
                width={24}
                height={24}
                src={isActive ? activeIcon : icon}
                alt={`${name} icon`}
                onClick={() => {
                  // if (id === "profile") {
                  //   handleProfileClick();
                  // }

                  if (id === "home" && pathname === "/fan/home") {
                    localStorage.setItem("isHome", "true");
                    window.dispatchEvent(new Event("localStorageChanged"));
                  }
                }}
              />
            </>
          )}
        </Space>
        {currentUserSettings && localStorage.getItem("shouldShowProfileModal") && !currentUserSettings?.visibilityStatus?.hasSeenProfileModal && (
          <FormationModalComponent id="profile-first-modal" visible={true} handleTutorialRead={handleTutorialRead} />
        )}
      </>
    );
  },
  (prevProps, nextProps) => prevProps.isActive === nextProps.isActive
);

export default FooterItemComponent;
